<script>
/**
 * Descripción: Pantalla para Gestionar Usuarios
 *
 * @displayName UserEditorViewComponent
 */

import { mapActions } from 'vuex';
import httpService from '@/services/httpService.js';
import BaseArrayHelper from '@/helpers/BaseArrayHelper.js';
import BaseNotificationsHelper from '@/helpers/BaseNotificationsHelper.js';

const InstanceByUserFilterViewComponent = () =>
  import('@/views/InstanceByUser/InstanceByUserFilterViewComponent.vue');

const ApplicationInstanceFilterViewComponent = () =>
  import(
    '@/views/ApplicationInstance/ApplicationInstanceFilterViewComponent.vue'
  );

export default {
  name: 'UserEditorViewComponent',

  components: {
    InstanceByUserFilterViewComponent,
    ApplicationInstanceFilterViewComponent
  },

  data() {
    return {
      user: this.$_setUserObject(),
      confirmUserPassword: undefined,
      loading: false,
      showPassword: false,
      extraParams: {
        userId: this.$router.currentRoute.params.Id
      }
    };
  },

  created() {
    /**
     * Configuracion Encabezado
     */
    this.addNavbar(['Gestionar Usuario']);

    /**
     * Determinar si Es nuevo / editor
     */
    this.$_getObject();
  },

  methods: {
    /**
     * Determinar si Es nuevo / editor
     */
    $_getObject() {
      let data = this.$router.currentRoute.params.Id;
      if (data) {
        //HttpServices a la vista para obtener Vista
        this.user.userId = data;
        this.loading = true;
        httpService.post('/User/GetView', this.user).then(response => {
          this.loading = false;
          if (response != undefined) {
            // Encontro la entidad
            this.user = BaseArrayHelper.SetObject({}, response.data);
            this.confirmUserPassword = this.user.userPassword;
          } else {
            this.$_returnToFilter();
          }
        });
      }
    },

    /**
     * Configuración NavBar
     */
    ...mapActions('navbar', ['addNavbar']),

    $_Password() {
      this.showPassword = !this.showPassword;
    },

    /**
     * Obj de la pantalla
     */
    $_setUserObject() {
      return {
        userId: undefined,
        userName: undefined,
        userLogin: undefined,
        userPassword: undefined,
        activo: true,
        profileId: undefined
      };
    },

    /**
     * Volver al Filtro
     */
    $_returnToFilter() {
      this.$router.push({ name: 'UserFilterViewComponent' });
    },

    $_sendToApi() {
      if (this.user.userPassword === this.confirmUserPassword) {
        this.loading = true;
        let object = BaseArrayHelper.SetObject({}, this.user);
        httpService.post('User/Save', object).then(response => {
          if (response != undefined) {
            //Logica JS luego de la acción exitosa!!!
            this.$router.push({ name: 'UserFilterViewComponent' });
          }
          this.loading = false;
        });
      } else {
        BaseNotificationsHelper.Message(true, 'Contraseñas diferentes');
      }
    },

    $_sendToApiInstances(params) {
      httpService
        .post(
          'InstanceByUser/SaveList',
          this.$_buildObject(params, this.$router.currentRoute.params.Id)
        )
        .then(response => {
          if (response != undefined) {
            //Logica JS luego de la acción exitosa!!!
            this.$refs.InstanceByUser.$_refresh();
            this.$refs.ApplicationInstance.$_refresh();
            this.$_openModal();
          }
        });
    },

    $_buildObject(params, userId) {
      let array = [];
      params.forEach(function filter(item) {
        array.push({
          userId: parseInt(userId),
          instanceId: item.instanceId
        });
      });

      return array;
    },

    fnDelete(params) {
      httpService
        .post(
          'InstanceByUser/Delete',
          this.$_buildObject(params, this.$router.currentRoute.params.Id)
        )
        .then(response => {
          if (response != undefined) {
            //Logica JS luego de la acción exitosa!!!
            this.$refs.InstanceByUser.$_refresh();
            this.$refs.ApplicationInstance.$_refresh();
          }
        });
    },

    /**
     * Open PopUp
     */
    $_openModal() {
      this.$refs.modalPopUp.$_openModal();
    }
  }
};
</script>

<template>
  <div>
    <!-- @ Use Loanding... -->
    <BaseSkeletonLoader v-if="loading" type="card-avatar, article, actions" />
    <div v-else>
      <!-- @BaseDialog -->
      <BaseDialog ref="modalPopUp" width="2000" tittle="Instancias Disponibles">
        <div slot="Content">
          <!-- @BaseMultiServicesDataTable -->
          <ApplicationInstanceFilterViewComponent
            :extraParams="extraParams"
            :footerMethod="$_sendToApiInstances"
            :cancel="$_openModal"
            ref="ApplicationInstance"
          />
        </div>
      </BaseDialog>
      <h3>Gestionar Usuario</h3>
      <v-divider></v-divider>
      <v-flex xs12 sm12 md12>
        <!-- @BaseForm -->
        <!-- @BaseForm -->
        <BaseForm :method="$_sendToApi" :cancel="$_returnToFilter">
          <div slot="body">
            <v-row>
              <v-col cols="12" md="4">
                <!-- @BaseInputList -->
                <BaseInput
                  label="Nombre"
                  v-model="user.userName"
                  :validate="['text']"
                  :max="100"
                />
              </v-col>
              <v-col cols="12" md="4">
                <!-- @BaseInputList -->
                <BaseInput
                  label="Usuario"
                  v-model="user.userLogin"
                  :validate="['text']"
                  :max="100"
                />
              </v-col>
              <v-col cols="12" md="4">
                <!-- @BaseSelect -->
                <BaseSelect
                  v-model="user.profileId"
                  label="Perfil"
                  endpoint="/Profile/GridWithList"
                  itemText="profileName"
                  itemValue="profileId"
                  :validate="['text']"
                />
              </v-col>
              <v-col cols="12" md="4">
                <!-- @BaseInputList -->
                <BaseInput
                  label="Contraseña"
                  :type="showPassword ? 'text' : 'password'"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :clickAppend="$_Password"
                  v-model="user.userPassword"
                  :validate="['text']"
                  :max="100"
                />
              </v-col>
              <v-col cols="12" md="4">
                <!-- @BaseInputList -->
                <BaseInput
                  label="Confirmación"
                  :type="showPassword ? 'text' : 'password'"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :clickAppend="$_Password"
                  v-model="confirmUserPassword"
                  :validate="['text']"
                  :max="100"
                />
              </v-col>
              <v-col cols="12" md="4">
                <div
                  class="pa-2"
                  style=" display: flex;
                        align-items: center;
                        justify-content: center;"
                >
                  <BaseSwitch v-model="user.activo" label="Estado" />
                </div>
              </v-col>
            </v-row>
          </div>
          <!-- @slot Use this slot afterForm -->
          <div slot="afterForm" v-if="this.$router.currentRoute.params.Id">
            <h3>Instancias Asignadas</h3>
            <v-divider></v-divider>
            <br />
            <InstanceByUserFilterViewComponent
              :extraParams="extraParams"
              :fnNew="$_openModal"
              :fnDelete="fnDelete"
              ref="InstanceByUser"
            />
          </div>
        </BaseForm>
      </v-flex>
    </div>
  </div>
</template>
